export default {
  props: {
    renderGeneration: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      highlighted: this.renderGeneration > 0
    }
  },
  mounted() {
    if (this.renderGeneration <= 0) {
      return
    }
    this.scrollIntoViewIfPossible()
    this.highlightTimer = setTimeout(() => {
      this.highlighted = false
    }, 1100)
  },
  beforeDestroy() {
    clearTimeout(this.highlightTimer)
  },
  methods: {
    scrollIntoViewIfPossible() {
      if (!this.$el || typeof this.$el.scrollIntoView !== 'function') {
        return
      }
      const prefersReducedMotion = typeof window !== 'undefined' && typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      this.$el.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'nearest' })
    }
  }
}
